/**
 * Blättchen-Pack-Hilfsfunktionen.
 * quantity in der DB = Anzahl einzelner Sheets (Option B — keine Schema-Migration).
 * Display und Transfer verwenden Pack-Einheiten (1 Pack = 42 Sheets).
 */

export const BLAETTCHEN_SHEETS_PER_PACK = 42;

/** Sheets-Schwellenwerte für Badge-Farbcodierung */
export const BLAETTCHEN_LOW_THRESHOLD = 10;   // < 10 Sheets → Rot
export const BLAETTCHEN_MED_THRESHOLD = 25;   // < 25 Sheets → Gelb, ≥ 25 → Grün

/**
 * Anzahl Packungen aus Sheet-Gesamtzahl (inkl. ggf. 1 angebrochene).
 * ceil(sheets / 42): 39 Sheets = 1 Packung (angebrochen), 42 = 1 Packung (voll), 43 = 2 Packungen.
 */
export function blaettchenPackCount(totalSheets: number): number {
  if (totalSheets <= 0) return 0;
  return Math.ceil(totalSheets / BLAETTCHEN_SHEETS_PER_PACK);
}

/**
 * Gibt die Anzahl voller Packungen zurück (floor).
 */
export function blaettchenFullPackCount(totalSheets: number): number {
  return Math.floor(totalSheets / BLAETTCHEN_SHEETS_PER_PACK);
}

/**
 * Konvertiert eine Pack-Anzahl (aus der UI) in Sheets für den Backend-API-Call.
 * Setzt die Transfer-Regel um: angebrochene Packung muss immer als Einheit mitgehen.
 *
 * Regeln:
 * - packs ≤ fullPacks → nur volle Packungen: packs × 42 Sheets
 * - packs > fullPacks → schließt die angebrochene Packung ein: alle totalSheets
 */
export function blaettchenPacksToSheets(packs: number, totalSheets: number): number {
  const fullPacks = blaettchenFullPackCount(totalSheets);
  if (packs <= fullPacks) return packs * BLAETTCHEN_SHEETS_PER_PACK;
  return totalSheets;
}

/**
 * CSS-Custom-Property-Name für Badge-Farbe basierend auf Gesamt-Sheet-Anzahl.
 */
export function blaettchenBadgeCssVar(totalSheets: number): string {
  if (totalSheets < BLAETTCHEN_LOW_THRESHOLD) return '--accent-red';
  if (totalSheets < BLAETTCHEN_MED_THRESHOLD) return '--accent-gold';
  return '--accent-green';
}
